module.exports = __webpack_public_path__ + "static/media/group-member-checked.15484ca5.svg";